import _regeneratorRuntime from "/data/maven/.jenkins/workspace/web/web/node_modules/@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { queryPageIntermediary, lookIntermediary, deleteIntermediary, saveIntermediary, prohibitIntermediary, importIntermediary, findAllCompany, getExcelPath, download } from "@/api/baseDataManage";
import { getCompanyList } from "@/api/baseDate";
export default {
  name: "BcIntermediary",
  data: function data() {
    var testEmail = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(rule, item, callback) {
        var re;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                re = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/g;

                if (!item) {
                  _context.next = 4;
                  break;
                }

                if (re.test(item)) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", callback(new Error('电子邮箱格式不正确')));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function testEmail(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      };
    }();

    var emailValidator = function emailValidator(rule, value, callback) {
      if (value) {
        var valueList = value.split(",");
        valueList.map(function (item) {
          testEmail(rule, item, callback);
        });
        callback();
      } else {
        callback();
      }
    };

    return {
      // activeA:false,
      activeAffiliationList1: [],
      activeAffiliationList2: [],
      riskView: false,
      // bcAgentManList: [],
      affiliationCom: "",
      //归属机构编辑/保存视图显示
      affiliationComList: [],
      fileList: [],
      company: "",
      //保险公司
      companyList: [],
      //获取保险公司列表并匹配1
      // 查询条件
      form: {
        affiliationComCode: "",
        //归属机构代码 String类型
        affiliationComName: "",
        //归属机构名称 String类型
        insuranceCompanyCode: "",
        //保险公司代码  !必传 String类型
        insuranceCompanyName: "",
        //保险公司名称 String类型
        intermediaryOrganCode: "",
        //中介机构代码
        intermediaryOrganName: "",
        //中介机构名称
        pageNo: 1,
        // int类型 –第几页 必传!
        pageSize: 10,
        // int 类型 –每页数量 必传!
        validStatus: "",
        //状态值
        validStatusName: ''
      },
      total: 0,
      //数据条数
      // 列表数据
      tableData: [],
      loading: false,
      screenLoading: null,
      newumarBtn: false,
      new_edit: false,
      editData: {},
      markForm: {
        activeA: '',
        activeAffiliationList: [],
        address: "",
        //地址
        affiliationComCode: "",
        //归属机构代码
        affiliationComName: "",
        //归属机构名称
        bcAgentManList: [{
          //经办人信息 数组(可能存在多条)
          agentManCode: "",
          //经办人代码string
          agentManName: "",
          //经办人名称string
          intermediaryOrganCode: "",
          //中介机构代码string
          intermediaryOrganName: "",
          //中介机构名称string
          agentManId: ''
        }],
        email: "",
        //邮箱
        intermediaryId: "",
        //主键 (有就传,没有就不传,编辑的时候是有的,单条新增的时候,是么有的)
        intermediaryOrganCode: "",
        //中介机构代码
        intermediaryOrganName: "",
        //中介机构名称
        phone: "",
        //电话
        type: "" //是否是编辑按钮 1-是,0-否 (如果是编辑按钮,如果是,就传1,如果是单条新增按钮,就传0) !必传

      },
      markForm_new: {
        activeA: '',
        activeAffiliationList: [],
        address: "",
        //地址
        affiliationComCode: "",
        //归属机构代码
        affiliationComName: "",
        //归属机构名称
        bcAgentManList: [],
        email: "",
        //邮箱
        intermediaryId: "",
        //主键 (有就传,没有就不传,编辑的时候是有的,单条新增的时候,是么有的)
        intermediaryOrganCode: "",
        //中介机构代码
        intermediaryOrganName: "",
        //中介机构名称
        phone: "",
        //电话
        type: "" //是否是编辑按钮 1-是,0-否 (如果是编辑按钮,如果是,就传1,如果是单条新增按钮,就传0) !必传

      },
      limitrule: {
        address: [{
          required: true,
          message: "请输入地址",
          trigger: "blur"
        }],
        affiliationComCode: [{
          required: true,
          message: "请选择归属机构",
          trigger: "blur"
        }],
        // email: [
        // 	{ required: false, message: "请输入电子邮箱", trigger: "blur" },
        // 	{ validator: emailValidator, message: '电子邮箱格式不正确' }
        //
        // ],
        email: [{
          validator: emailValidator,
          trigger: 'blur'
        }],
        intermediaryOrganCode: [{
          required: true,
          message: "请输入中介机构代码",
          trigger: "blur"
        }],
        intermediaryOrganName: [{
          required: true,
          message: "请输入中介机构名称",
          trigger: "blur"
        }],
        phone: [{
          required: true,
          message: "请输入电话号码",
          trigger: "blur"
        }, {
          min: 0,
          max: 15,
          message: '长度最长为15个字符',
          trigger: 'blur'
        }]
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    getCompanyList().then(function (res) {
      _this.companyList = Object.assign([], res); // this.company = this.form.insuranceCompanyCode = this.$store.state.user.userinfo.insuranceCompanyList[0].insuranceCompanyCode
      // this.company = this.form.insuranceCompanyCode = JSON.parse(sessionStorage.getItem("newinsurancecompanyCode"));

      _this.company = _this.form.insuranceCompanyCode = JSON.parse(sessionStorage.getItem('newinsurancecompanyCode'));

      _this.getData();
    });
  },
  methods: {
    //  经办人删除
    deleteLimitlInfo: function deleteLimitlInfo(row, type) {
      var _this2 = this;

      console.log(row.$index);
      this.$confirm('是否要删除该经办人?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        if (type == 'edit') {
          _this2.markForm.bcAgentManList.splice(row.$index, 1);

          console.log(_this2.markForm.bcAgentManList);
        } else {
          _this2.markForm_new.bcAgentManList.splice(row.$index, 1);
        }

        _this2.$forceUpdate();
      });
    },
    //经办人新增
    addLimitlInfo: function addLimitlInfo(type) {
      if (type == 'edit') {
        // this.bcAgentManList = this.markForm.bcAgentManList || []
        this.markForm.bcAgentManList.push({
          agentManCode: '',
          agentManName: '',
          // intermediaryOrganCode: this.markForm.intermediaryOrganCode,
          // intermediaryOrganName: this.markForm.intermediaryOrganName,
          agentManId: ''
        });
      } else {
        this.markForm_new.bcAgentManList.push({
          agentManCode: '',
          agentManName: '',
          // intermediaryOrganCode: this.markForm_new.intermediaryOrganCode,
          // intermediaryOrganName: this.markForm_new.intermediaryOrganName,
          agentManId: ''
        });
      }
    },
    // 归属机构列表变化
    changeaffiliationCom: function changeaffiliationCom(e) {
      console.log(e, 'eee');
      this.markForm_new.affiliationComCode = '';
      this.markForm_new.affiliationComName = '';
      this.markForm.affiliationComCode = '';
      this.markForm.affiliationComName = '';
      var activeAffiliationList = [];
      var that = this;
      e.forEach(function (val) {
        activeAffiliationList.push({
          affiliationCode: val.split('-')[0],
          affiliationName: val.split('-')[1]
        });

        if (that.markForm_new.affiliationComCode != '') {
          that.markForm_new.affiliationComCode += '|';
          that.markForm_new.affiliationComName += '|';
          that.markForm.affiliationComCode += '|';
          that.markForm.affiliationComName += '|';
        }

        that.markForm_new.affiliationComCode += val.split('-')[0];
        that.markForm_new.affiliationComName += val.split('-')[1];
        that.markForm.affiliationComCode += val.split('-')[0];
        that.markForm.affiliationComName += val.split('-')[1];
      });
      console.log(activeAffiliationList);
      console.log(this.markForm_new.affiliationComCode);
    },
    // 获取归属机构list
    findAllList: function findAllList() {
      var _this3 = this;

      findAllCompany().then(function (res) {
        // console.log(res);
        _this3.affiliationComList = Object.assign([], res);
      });
    },
    // 新增
    newbut: function newbut() {
      this.newumarBtn = true;
      this.findAllList(); // this.affiliationCom = ""; //
    },
    // 查询是否有效 下拉框change
    changeStatus: function changeStatus(e) {
      console.log(e);
      this.form.validStatus = e.toString();
    },
    // --------------------------------------------
    //   查询
    submitForm: function submitForm(formName) {
      this.form.pageNo = 1;
      this.getData();
    },
    getData: function getData() {
      var _this4 = this;

      this.loading = true;
      queryPageIntermediary(_objectSpread({}, this.form)).then(function (res) {
        console.log(res);
        _this4.loading = false;
        _this4.total = res.totalCount;
        _this4.tableData = Object.assign([], res.content);
      });
    },
    //   重置查询条件
    resetForm: function resetForm(formName) {
      // this.$refs[formName].resetFields();
      this.form.affiliationComCode = "", //归属机构代码 String类型
      this.form.affiliationComName = "", //归属机构名称 String类型
      this.form.intermediaryOrganCode = "", //中介机构代码
      this.form.intermediaryOrganName = "", //中介机构名称
      this.form.validStatus = "", //状态值
      this.form.validStatusName = "";
      this.getData();
    },
    // 分页方法
    handleSizeChange: function handleSizeChange(val) {
      this.form.pageSize = val;
      this.getData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.form.pageNo = val;
      this.getData();
    },
    //编辑/新增保存
    editSave: function editSave(formName, type) {
      var _this5 = this;

      var that = this;
      var data = type == "edit" ? this.markForm : this.markForm_new;

      if (type == "edit") {
        this.markForm.type = "1";
        this.markForm.bcAgentManList.forEach(function (val) {
          val.intermediaryOrganCode = that.markForm.intermediaryOrganCode;
          val.intermediaryOrganName = that.markForm.intermediaryOrganName;
        });
      } else {
        this.markForm_new.type = "0";
        this.markForm_new.bcAgentManList.forEach(function (val) {
          val.intermediaryOrganCode = that.markForm_new.intermediaryOrganCode;
          val.intermediaryOrganName = that.markForm_new.intermediaryOrganName;
        });
        console.log(this.markForm_new);
      }

      console.log(data);
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          if (data.bcAgentManList.length != 0) {
            if (data.bcAgentManList[0].agentManCode !== '' && data.bcAgentManList[0].agentManName !== '') {
              console.log('正确'); // this.markForm.activeA = this.markForm_new.activeA = false

              _this5.new_edit = _this5.newumarBtn = false;

              _this5.openFullScreen();

              saveIntermediary(data).then(function (res) {
                if (res.resultCode == "0000") {
                  _this5.$message({
                    message: "保存成功",
                    type: "success"
                  });

                  for (var key in _this5.markForm_new) {
                    _this5.markForm_new[key] = "";
                  }

                  _this5.markForm_new.bcAgentManList = [];
                  _this5.activeAffiliationList2 = [];

                  _this5.getData();
                } else {
                  _this5.$alert(res.resultMsg, '', {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: '确定',
                    callback: function callback(action) {
                      _this5.newumarBtn = type == 'new' ? true : false;
                      _this5.new_edit = type == 'edit' ? true : false;
                    }
                  });
                }

                _this5.screenLoading.close();

                _this5.affiliationCom = ""; //
              });
            } else {
              _this5.markForm.activeA = type == 'edit' ? '2' : '';
              _this5.markForm_new.activeA = type == 'new' ? '2' : '';
              console.log(_this5.markForm_new.activeA);
            }
          } else {
            _this5.markForm.activeA = type == 'edit' ? '1' : '';
            _this5.markForm_new.activeA = type == 'new' ? '1' : '';
            console.log(_this5.markForm_new.activeA);
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 编辑
    edit: function edit(data) {
      var _this6 = this;

      console.log(data);
      this.new_edit = true;
      this.findAllList();
      var code = data.affiliationComCode.split('|');
      var name = data.affiliationComName.split('|');
      var activeAffiliationList = [];
      code.forEach(function (val, index) {
        activeAffiliationList.push(val + '-' + name[index]);
      });
      this.activeAffiliationList1 = activeAffiliationList;
      console.log(this.markForm);
      lookIntermediary({
        intermediaryId: data.intermediaryId
      }).then(function (res) {
        _this6.editData = Object.assign([], res);
        console.log(res);
        _this6.markForm.bcAgentManList = res.bcAgentManList;

        for (var key in _this6.markForm) {
          _this6.markForm[key] = res[key];
        }
      });
    },
    // 删除
    dele: function dele(data) {
      var _this7 = this;

      console.log(data);
      this.$confirm('此操作将永久删除该中介机构, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        deleteIntermediary({
          intermediaryId: data.intermediaryId,
          intermediaryOrganCode: data.intermediaryOrganCode
        }).then(function (res) {
          // console.log(res)
          if (res.resultCode == '0000') {
            _this7.$message({
              type: 'success',
              message: '删除成功!'
            });

            _this7.getData();
          } else {
            _this7.$message({
              type: 'warning',
              message: res.resultMsg
            });
          }
        });
      }).catch(function () {
        _this7.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    // 禁用
    noRight: function noRight(data, status) {
      var _this8 = this;

      console.log(data);
      var str = "";
      if (status == "0") str = "禁用";else str = "启用";
      this.$confirm("\u6B64\u64CD\u4F5C\u5C06".concat(str, "\u8BE5\u4E2D\u4ECB\u673A\u6784, \u662F\u5426\u7EE7\u7EED?"), "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        prohibitIntermediary({
          intermediaryId: data.intermediaryId,
          status: status
        }).then(function (res) {
          if (res.resultCode == "0000") {
            _this8.$message({
              type: "success",
              message: res.resultMsg
            });

            _this8.getData(1);
          } else {
            _this8.$message({
              type: "warning",
              message: res.resultMsg
            });
          }
        });
      }).catch(function () {
        _this8.$message({
          type: "info",
          message: "已取消操作"
        });
      });
    },
    // 取消
    selectcancel: function selectcancel(formname, type) {
      var _this9 = this;

      if (type == "new") {
        this.newumarBtn = false;
      } else {
        this.new_edit = false;
      }

      this.$nextTick(function () {
        _this9.$refs[formname].clearValidate();
      });
      this.affiliationCom = ""; // this.markForm_new.activeA = this.markForm.activeA = false
    },
    // 获取下载链接
    getExecl: function getExecl() {
      getExcelPath({
        fileDownloadType: 'intermediary'
      }).then(function (res) {
        if (res.rtnCode == '0000') {
          // 获取下载文件
          download({
            fileSrc: res.fileSrc
          }).then(function (res2) {
            var blob = new Blob([res2], {
              type: "application/vnd.ms-excel"
            }); // 兼容ie

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(blob, "中介机构导入模板.xlsx");
            } else {
              var url = window.URL.createObjectURL(blob);
              var link = document.createElement("a"); // 创建a标签

              link.href = url;
              link.download = "中介机构导入模板.xlsx"; // 重命名文件

              link.click();
              window.URL.revokeObjectURL(url); // 释放内存
            }
          });
        }
      });
    },
    openFullScreen2: function openFullScreen2() {
      this.screenLoading = this.$loading({
        lock: true,
        text: "导入中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
    },
    openFullScreen: function openFullScreen() {
      this.screenLoading = this.$loading({
        lock: true,
        text: "请求中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
    },
    // 上传
    importExcel: function importExcel(file) {
      var _this10 = this;

      var extension = file.file.name.substring(file.file.name.lastIndexOf(".") + 1);

      if (extension !== "xlsx" && extension !== "xls") {
        this.$message.warning("只能上传后缀是.xlsx或者.xls的文件");
        return;
      }

      var dataFile = new FormData();
      dataFile.append("file", file.file);
      this.openFullScreen2();
      importIntermediary(dataFile).then(function (res) {
        _this10.screenLoading.close();

        if (res.resultCode == "0000") {
          _this10.$message({
            type: "success",
            message: "导入成功"
          });

          _this10.getData();
        } else {
          _this10.$message({
            type: "warning",
            message: res.resultMsg
          });
        }
      });
    }
  }
};